import React from 'react';
import ContentfulImage from '@moxy/react-contentful-image';
import { Tracking } from 'web-core/src/tracking';
import HighlightHeader, { HighlightHeaderType } from 'client/components/highlightHeader';
import { ContentfulImageSetType } from 'types/globals/contentful';
import useSearchParams from 'client/hooks/useSearchParams';

export type HealthCoverageCta = {
  text: string;
  url: string;
  trackingEvent: string;
};

type Props = {
  header: HighlightHeaderType;
  subHeader: string;
  items: ContentfulImageSetType[];
  cta: HealthCoverageCta;
};

const HealthCoverage = ({ header, items, subHeader, cta }: Props) => {
  const searchParams = useSearchParams();

  return (
    <section className="health-coverage-section last-section-pad-bottom">
      <div className="row">
        <h2 className="margin-bottom-2">
          <HighlightHeader {...header} />
        </h2>
        <h4 className="bold margin-bottom">{subHeader}</h4>
        <div className="items">
          {items?.map(({ name, main: { file, title }, key }) => (
            <figure key={key} className="item">
              <ContentfulImage alt={title} image={file.url} />
              <figcaption>{name}</figcaption>
            </figure>
          ))}
        </div>
        <a
          className="button primary margin-top"
          onClick={() =>
            Tracking.track(cta.trackingEvent, {
              cta: cta.text,
            })
          }
          href={`${cta.url}${searchParams}`}>
          {cta.text}
        </a>
      </div>
    </section>
  );
};

export default HealthCoverage;
